var _a;
import { Sound } from "@babylonjs/core/Audio/sound";
import { ListenableEvent, Log } from '@egr/wcf/modules/utils';
import { PropertyValue } from '@egr/wcf/modules/core/prop';
import { clamp } from '@egr/wcf/modules/utils/math';
import { ajax } from '@egr/wcf/modules/utils/async';
import { RoomManager } from "../RoomManager";
import { Util } from "./Util";
var SoundType;
(function (SoundType) {
    SoundType[SoundType["music"] = 0] = "music";
    SoundType[SoundType["effect"] = 1] = "effect";
})(SoundType || (SoundType = {}));
export const ERR_NO_FILE_VIA_URL = "No file available (via URL)!";
export const ERR_SOUNDID_NOT_FOUND = "Sound not found!";
export async function loadSoundFile(pURL) {
    try {
        return await ajax("GET", pURL + Util.URLrandomAddOn(), null, { responseType: 'arraybuffer' });
    }
    catch (e) {
        // console.log(pURL + ' File was not found!');
    }
    finally {
        //...
    }
    return Promise.resolve(null);
}
export class BackgroundSound {
    constructor(pRoomManager) {
        this.eventPreviewReadyToPlay = new ListenableEvent(this);
        this.eventMusicReadyToPlay = new ListenableEvent(this);
        this.eventEffectReadyToPlay = new ListenableEvent(this);
        this.eventPreviewStopped = new ListenableEvent(this);
        this.eventMusicStopped = new ListenableEvent(this);
        this.eventEffectStopped = new ListenableEvent(this);
        this.bgMusic_ReadyToPlay = () => {
            this._clearTimeouts();
            this.stop_preview();
            this.eventMusicReadyToPlay.trigger(this);
            if (this.mautoPlay_music) {
                setTimeout(() => {
                    // this.mSound_BGMusic?.play();
                    this.checkFadeInOut(this.mSound_BGMusic, this.mBackground_Music);
                }, 20);
            }
        };
        this.bgEffect_ReadyToPlay = () => {
            this._clearTimeouts();
            this.stop_preview();
            this.eventEffectReadyToPlay.trigger(this);
            if (this.mautoPlay_effect) {
                setTimeout(() => {
                    // this.mSound_BGEffect?.play();
                    this.checkFadeInOut(this.mSound_BGEffect, this.mBackground_Effect);
                }, 20);
            }
        };
        this.preview_ended = (pSound, eventState) => {
            this._clearTimeouts();
            this.eventPreviewStopped.trigger(this);
            this.resume_Play();
        };
        this.onLanguageChanged = () => {
            this.prepareValueLists();
            this.getSoundEffectList();
        };
        this.mRoomManager = pRoomManager;
        this.mextSoundEffectisLoading = false;
        this.mExtLoadedSoundEffects = new Array();
        this.mExtLoadedSoundCategory = new Array();
        this.mextSoundEffectisLoading = false;
        this.marr_TimeOut = [];
        this.mautoPlay_music = false;
        this.mautoPlay_effect = false;
        this.mfileLoaded_music = '';
        this.mfileLoaded_effect = '';
        this.mfileLoaded_preview = '';
        this.mMusic_played = false;
        this.mEffect_played = false;
        this.mFadeInDoneMusic = false;
        this.mFadeInDoneEffect = false;
        this.mCurrPreCat = '';
        this.mRoomManager.app.i18n.eventLanguageChanged.addListener(this.onLanguageChanged);
        // this.eventMusicReadyToPlay.addListener(this._MusicReadyToPlay);
        // this.eventEffectReadyToPlay.addListener(this._EffectReadyToPlay);
        this.getSoundEffectList();
        this.prepareValueLists();
        this.setAudioBackground_init();
        this.bgMusic_ended = this.bgMusic_ended.bind(this);
    }
    get choiceList_effect() {
        return (this.mPropVal_background_effect);
    }
    get choiceList_music() {
        return (this.mPropVal_background_music);
    }
    get audioData_Music() {
        const tsoundId = this.mBackground_Music.soundSet.category + RoomManager.CATVALUE_SPLITTER + this.mBackground_Music.soundSet.id;
        const tAED = {};
        tAED.soundId = tsoundId;
        tAED.fadeIn = this.mBackground_Music.fadeIn;
        tAED.fadeOut = this.mBackground_Music.fadeOut;
        tAED.loop = this.mBackground_Music.loop;
        tAED.volume = this.mBackground_Music.volume;
        tAED.autoPlay = this.mBackground_Music.autoplay;
        tAED.type = this.mBackground_Music.type;
        return (tAED);
    }
    get audioData_Effect() {
        const tsoundId = this.mBackground_Effect.soundSet.category + RoomManager.CATVALUE_SPLITTER + this.mBackground_Effect.soundSet.id;
        const tAED = {};
        tAED.soundId = tsoundId;
        tAED.fadeIn = this.mBackground_Effect.fadeIn;
        tAED.fadeOut = this.mBackground_Effect.fadeOut;
        tAED.loop = this.mBackground_Effect.loop;
        tAED.volume = this.mBackground_Effect.volume;
        tAED.autoPlay = this.mBackground_Effect.autoplay;
        tAED.type = this.mBackground_Effect.type;
        return (tAED);
    }
    get fileData_music() {
        var _b, _c, _d;
        if ((_d = (_c = (_b = this.mSound_BGMusic) === null || _b === void 0 ? void 0 : _b.getAudioBuffer) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 ? void 0 : _d.duration) {
            const tduration = this.mSound_BGMusic.getAudioBuffer().duration;
            const tcurrentPos = this.mSound_BGMusic.currentTime;
            const tAPD = {};
            tAPD.duration = tduration;
            tAPD.current = tcurrentPos;
            return (tAPD);
        }
        return (null);
    }
    get fileData_effect() {
        var _b, _c, _d;
        if ((_d = (_c = (_b = this.mSound_BGEffect) === null || _b === void 0 ? void 0 : _b.getAudioBuffer) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 ? void 0 : _d.duration) {
            const tduration = this.mSound_BGEffect.getAudioBuffer().duration;
            const tcurrentPos = this.mSound_BGEffect.currentTime;
            const tAPD = {};
            tAPD.duration = tduration;
            tAPD.current = tcurrentPos;
            return (tAPD);
        }
        return (null);
    }
    get externalSoundEffectList() {
        return (this.mExtLoadedSoundEffects);
    }
    get autoPlay_music() {
        return (this.mautoPlay_music);
    }
    set autoPlay_music(pVal) {
        this.mautoPlay_music = pVal;
        this.mMusic_played = pVal;
        if (pVal) {
            this.mFadeInDoneMusic = false;
            this.play_music();
            return;
        }
        this.stop_music();
    }
    get autoPlay_effect() {
        return (this.mautoPlay_effect);
    }
    set autoPlay_effect(pVal) {
        this.mautoPlay_effect = pVal;
        this.mEffect_played = pVal;
        if (pVal) {
            this.mFadeInDoneEffect = false;
            this.play_effect();
            return;
        }
        this.stop_effect();
    }
    get fadeIn_music() {
        return (this.mBackground_Music.fadeIn);
    }
    set fadeIn_music(pVal) {
        this.mBackground_Music.fadeIn = pVal;
    }
    get fadeOut_music() {
        return (this.mBackground_Music.fadeOut);
    }
    set fadeOut_music(pVal) {
        this.mBackground_Music.fadeOut = pVal;
    }
    get fadeIn_effect() {
        return (this.mBackground_Effect.fadeIn);
    }
    set fadeIn_effect(pVal) {
        this.mBackground_Effect.fadeIn = pVal;
    }
    get fadeOut_effect() {
        return (this.mBackground_Effect.fadeOut);
    }
    set fadeOut_effect(pVal) {
        this.mBackground_Effect.fadeOut = pVal;
    }
    dispose() {
        this._clearTimeouts();
        if (this.mSound_Preview != null) {
            this.stopAudio(this.mSound_Preview);
        }
        if (this.mSound_BGEffect != null) {
            this.stopAudio(this.mSound_BGEffect);
        }
        if (this.mSound_BGMusic != null) {
            this.stopAudio(this.mSound_BGMusic);
        }
        this.setAudioBackground_init();
    }
    setAudioData_Music(pAudioExportData) {
        if (pAudioExportData.fadeIn != null) {
            this.mBackground_Music.fadeIn = pAudioExportData.fadeIn;
        }
        if (pAudioExportData.fadeOut != null) {
            this.mBackground_Music.fadeOut = pAudioExportData.fadeOut;
        }
        if (pAudioExportData.volume != null) {
            this.mBackground_Music.volume = pAudioExportData.volume;
        }
        // if (pAudioExportData.loop != null) {
        //     this.mBackground_Music.loop = pAudioExportData.loop;
        // }
        // if (pAudioExportData.autoPlay != null) {
        //     this.mBackground_Music.autoplay = pAudioExportData.autoPlay;
        // }
        if (pAudioExportData.soundId != null) {
            this.setFile_music(pAudioExportData.soundId);
        }
        if (pAudioExportData.type != null) {
            this.mBackground_Music.type = pAudioExportData.type;
        }
        else {
            this.mBackground_Music.type = SoundType.music;
        }
    }
    setAudioData_Effect(pAudioExportData) {
        if (pAudioExportData.fadeIn != null) {
            this.mBackground_Effect.fadeIn = pAudioExportData.fadeIn;
        }
        if (pAudioExportData.fadeOut != null) {
            this.mBackground_Effect.fadeOut = pAudioExportData.fadeOut;
        }
        if (pAudioExportData.volume != null) {
            this.mBackground_Effect.volume = pAudioExportData.volume;
        }
        // if (pAudioExportData.loop != null) {
        //     this.mBackground_Effect.loop = pAudioExportData.loop;
        // }
        // if (pAudioExportData.autoPlay != null) {
        //     this.mBackground_Effect.autoplay = pAudioExportData.autoPlay;
        // }
        if (pAudioExportData.soundId != null) {
            this.setFile_effect(pAudioExportData.soundId);
        }
        if (pAudioExportData.type != null) {
            this.mBackground_Effect.type = pAudioExportData.type;
        }
        else {
            this.mBackground_Effect.type = SoundType.effect;
        }
    }
    setFile_music(pSoundId) {
        const tnewSoundSet = this.getSoundEffectsById(pSoundId);
        if (tnewSoundSet == null) {
            Log.error("SoundId not found! -> " + pSoundId + " <-", ERR_SOUNDID_NOT_FOUND);
            return;
        }
        if (tnewSoundSet.id === 'none') {
            this.mBackground_Music.soundSet = tnewSoundSet;
            this.stop_music();
            return;
        }
        this.mBackground_Music.soundSet = tnewSoundSet;
        if (this.mautoPlay_music) {
            this.mFadeInDoneMusic = false;
            this.play_music();
        }
    }
    setFile_effect(pSoundId) {
        const tnewSoundSet = this.getSoundEffectsById(pSoundId);
        if (tnewSoundSet == null) {
            Log.error("SoundId not found! -> " + pSoundId + " <-", ERR_SOUNDID_NOT_FOUND);
            return;
        }
        if (tnewSoundSet.id === 'none') {
            this.mBackground_Effect.soundSet = tnewSoundSet;
            this.stop_effect();
            return;
        }
        this.mBackground_Effect.soundSet = tnewSoundSet;
        if (this.mautoPlay_effect) {
            this.mFadeInDoneEffect = false;
            this.play_effect();
        }
    }
    setVolume_music(pValue) {
        var _b, _c;
        let tValue = clamp(pValue, 0, 100);
        this.mBackground_Music.volume = tValue;
        (_b = this.mSound_BGMusic) === null || _b === void 0 ? void 0 : _b.setVolume(tValue * 0.01);
        if (this.mCurrPreCat === BackgroundSound.BACKGROUND_MUSIC) {
            (_c = this.mSound_Preview) === null || _c === void 0 ? void 0 : _c.setVolume(tValue * 0.01);
        }
    }
    setVolume_effect(pValue) {
        var _b, _c;
        let tValue = clamp(pValue, 0, 100);
        this.mBackground_Effect.volume = tValue;
        (_b = this.mSound_BGEffect) === null || _b === void 0 ? void 0 : _b.setVolume(tValue * 0.01);
        (_c = this.mSound_Preview) === null || _c === void 0 ? void 0 : _c.setVolume(tValue * 0.01);
    }
    /**
     *
     * playing preview of audio file
     * parameter:
     * soundId
     * duration: in seconds
     *
     */
    play_preview(pSoundId, pDuration) {
        const tsndSet = this.getSoundEffectsById(pSoundId);
        if (tsndSet == null) {
            Log.error("SoundId not found! -> " + pSoundId + " <-", ERR_SOUNDID_NOT_FOUND);
            this._clearTimeouts();
            this.stopAllSound();
            return;
        }
        this.mMusic_played = this.autoPlay_music;
        this.mEffect_played = this.autoPlay_effect;
        this._clearTimeouts();
        this.stopAllSound();
        const tsameFile = this.mfileLoaded_preview === tsndSet.fileURL;
        this.mPreview_Data.soundSet = tsndSet;
        this.checkFile(this.mSound_Preview, this.mPreview_Data, !tsameFile).then((pFile) => {
            var _b;
            if (pFile == null) {
                this.mPreview_Data.soundSet.category = "none";
                this.mPreview_Data.soundSet.id = '';
                this.mfileLoaded_preview = '';
                Log.error("Failed to load sound file: " + this.mPreview_Data.soundSet.fileURL, ERR_NO_FILE_VIA_URL);
                return;
            }
            const tsndCat = tsndSet.category.toLocaleLowerCase();
            let tvolume = 20;
            if (tsndCat === BackgroundSound.BACKGROUND_MUSIC) {
                tvolume = this.mBackground_Music.volume;
            }
            if (tsndCat === BackgroundSound.BACKGROUND_EFFECT) {
                tvolume = this.mBackground_Effect.volume;
            }
            if (pFile == true) {
                if (pDuration) {
                    this.eventPreviewReadyToPlay.trigger(this);
                    (_b = this.mSound_Preview) === null || _b === void 0 ? void 0 : _b.play();
                    this.marr_TimeOut.push(setTimeout(() => {
                        this.eventPreviewStopped.trigger(this);
                        this.stop_preview(true);
                    }, pDuration * 1000));
                }
                return;
            }
            if (!(pFile instanceof ArrayBuffer)) {
                return;
            }
            this.mPreview_Data.soundSet = tsndSet;
            this.mfileLoaded_preview = this.mPreview_Data.soundSet.fileURL;
            setTimeout(() => {
                if (this.mSound_Preview != null) {
                    this.mSound_Preview.dispose();
                    this.mSound_Preview = null;
                }
                this.mSound_Preview = new Sound("sound_Preview_Sphere", pFile, this.mRoomManager.app.scene, () => {
                    var _b, _c;
                    //
                    this.eventPreviewReadyToPlay.trigger(this);
                    this.mCurrPreCat = tsndCat;
                    (_b = this.mSound_Preview) === null || _b === void 0 ? void 0 : _b.onEndedObservable.add(this.preview_ended);
                    (_c = this.mSound_Preview) === null || _c === void 0 ? void 0 : _c.play();
                    if (pDuration) {
                        this.marr_TimeOut.push(setTimeout(() => {
                            this.eventPreviewStopped.trigger(this);
                            this.stop_preview(true);
                        }, pDuration * 1000));
                    }
                }, { loop: false, autoplay: false, volume: tvolume * 0.01 });
            }, 10);
        });
    }
    stop_preview(pResume = false) {
        if (this.mSound_Preview) {
            this.mSound_Preview.stop();
            this.eventPreviewStopped.trigger(this);
        }
        if (pResume) {
            this.resume_Play();
        }
    }
    pause_music() {
        var _b;
        (_b = this.mSound_BGMusic) === null || _b === void 0 ? void 0 : _b.pause();
    }
    stop_music() {
        if (this.mSound_BGMusic) {
            this.mFadeInDoneMusic = false;
            this.mSound_BGMusic.stop();
            this.eventMusicStopped.trigger(this);
        }
    }
    pause_effect() {
        var _b;
        (_b = this.mSound_BGEffect) === null || _b === void 0 ? void 0 : _b.pause();
    }
    stop_effect() {
        if (this.mSound_BGEffect) {
            this.mFadeInDoneEffect = false;
            this.mSound_BGEffect.stop();
            this.eventEffectStopped.trigger(this);
        }
    }
    getPropVal_music() {
        const tcat = this.mBackground_Music.soundSet.category;
        const tid = this.mBackground_Music.soundSet.id;
        const tPropVal = this.getSoundEffectPropValue(tcat, tid);
        return (tPropVal);
    }
    getPropVal_effect() {
        const tcat = this.mBackground_Effect.soundSet.category;
        const tid = this.mBackground_Effect.soundSet.id;
        const tPropVal = this.getSoundEffectPropValue(tcat, tid);
        return (tPropVal);
    }
    preparePropList_effects() {
        this.mPropVal_background_effect = new Array();
        let tLang = this.mRoomManager.getLocaleLanguage();
        for (const tsoundEffect of this.mExtLoadedSoundEffects) {
            if (tsoundEffect.category != RoomManager.AUDIO_BACKGROUND_EFFECT) {
                continue;
            }
            let tdescr = this.getSoundEffectsTextByEntry(tsoundEffect, tLang);
            const tsoundEffectProp = new PropertyValue();
            tsoundEffectProp.value = tsoundEffect.category + RoomManager.CATVALUE_SPLITTER + tsoundEffect.id;
            tsoundEffectProp.text = tdescr;
            this.mPropVal_background_effect.push(tsoundEffectProp);
        }
    }
    preparePropList_music() {
        this.mPropVal_background_music = new Array();
        let tLang = this.mRoomManager.getLocaleLanguage();
        for (const tsoundEffect of this.mExtLoadedSoundEffects) {
            if (tsoundEffect.category != RoomManager.AUDIO_BACKGROUND_MUSIC) {
                continue;
            }
            let tdescr = this.getSoundEffectsTextByEntry(tsoundEffect, tLang);
            const tsoundEffectProp = new PropertyValue();
            tsoundEffectProp.value = tsoundEffect.category + RoomManager.CATVALUE_SPLITTER + tsoundEffect.id;
            tsoundEffectProp.text = tdescr;
            this.mPropVal_background_music.push(tsoundEffectProp);
        }
    }
    // private _MusicReadyToPlay = (): void =>
    // {
    //     console.log("Music ready to play");
    // };
    // private _EffectReadyToPlay = (): void =>
    // {
    //     console.log("Effect ready to play");
    // };
    get fadeInDoneMusic() {
        return (this.mFadeInDoneMusic);
    }
    set fadeInDoneMusic(pVal) {
        this.mFadeInDoneMusic = pVal;
    }
    get fadeInDoneEffect() {
        return (this.mFadeInDoneEffect);
    }
    set fadeInDoneEffect(pVal) {
        this.mFadeInDoneEffect = pVal;
    }
    async checkFile(pSound, pAudioData, pforceLoad) {
        const taudioBuffer = pSound === null || pSound === void 0 ? void 0 : pSound.getAudioBuffer();
        if (taudioBuffer && taudioBuffer.length > 0 && !pforceLoad) {
            return (true);
        }
        const tFile = await loadSoundFile(pAudioData.soundSet.fileURL);
        return (tFile);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    async loadSoundFiles() {
        let tUrl = "";
        if (this.mRoomManager.soundJsonURL != null && this.mRoomManager.soundJsonURL.trim() !== "") {
            tUrl = this.mRoomManager.soundJsonURL;
        }
        else {
            tUrl = this.mRoomManager.dataPath + "soundeffects/soundeffects.json";
        }
        //let tJsonData: any = await ajax("GET", tUrl + Util.URLrandomAddOn());
        let tJsonData = await this.mRoomManager._loadJSON(tUrl);
        if (tJsonData == null) {
            return (Promise.resolve(false));
        }
        let tJSstr = JSON.stringify(tJsonData);
        let tJSobj = JSON.parse(tJSstr);
        if (tJSobj.hasOwnProperty("category")) {
            for (let tkeyCategory of tJSobj["category"]) {
                if (tkeyCategory.hasOwnProperty("id") &&
                    tkeyCategory.hasOwnProperty("translation")) {
                    let tSndCategory = {};
                    tSndCategory.id = tkeyCategory["id"];
                    if (tkeyCategory.hasOwnProperty("filter_include")) {
                        tSndCategory.filter_include = tkeyCategory["filter_include"];
                    }
                    else {
                        tSndCategory.filter_include = "";
                    }
                    if (tkeyCategory.hasOwnProperty("filter_exclude")) {
                        tSndCategory.filter_exclude = tkeyCategory["filter_exclude"];
                    }
                    else {
                        tSndCategory.filter_exclude = "";
                    }
                    tSndCategory.translation = new Array();
                    for (let tTrans of tkeyCategory["translation"]) {
                        if (tTrans.hasOwnProperty("lang") &&
                            tTrans.hasOwnProperty("text")) {
                            let tarrTrans = {};
                            tarrTrans.lang = tTrans["lang"];
                            tarrTrans.text = tTrans["text"];
                            tSndCategory.translation.push(tarrTrans);
                        }
                    }
                    let tSndCatexists = this.isSoundCategoryAlreadyAvailable(tSndCategory);
                    if (!tSndCatexists)
                        this.mExtLoadedSoundCategory.push(tSndCategory);
                }
            }
        }
        if (tJSobj.hasOwnProperty("soundeffects")) {
            for (let tkeySoundEffects of tJSobj["soundeffects"]) {
                if (tkeySoundEffects.hasOwnProperty("category") &&
                    tkeySoundEffects.hasOwnProperty("id") &&
                    tkeySoundEffects.hasOwnProperty("fileURL") &&
                    tkeySoundEffects.hasOwnProperty("translation")) {
                    const tcat = tkeySoundEffects["category"].trim();
                    const tid = tkeySoundEffects["id"].trim();
                    let tfileUrl = tkeySoundEffects["fileURL"].trim();
                    if (tcat === '' || tid === '' ||
                        (tid.toLocaleLowerCase() != "none") && tfileUrl === '') {
                        continue;
                    }
                    if (tfileUrl.length > 0 && tfileUrl.indexOf('http') != 0) {
                        tfileUrl = this.mRoomManager.dataPath + tfileUrl;
                    }
                    const tSoundData = {};
                    tSoundData.category = tcat;
                    tSoundData.id = tid;
                    tSoundData.fileURL = tfileUrl;
                    if (tkeySoundEffects.hasOwnProperty("description")) {
                        tSoundData.description = tkeySoundEffects["description"];
                    }
                    else {
                        tSoundData.description = "";
                    }
                    tSoundData.translation = new Array();
                    for (let tTrans of tkeySoundEffects["translation"]) {
                        if (tTrans.hasOwnProperty("lang") &&
                            tTrans.hasOwnProperty("text")) {
                            let tarrTrans = {};
                            tarrTrans.lang = tTrans["lang"];
                            tarrTrans.text = tTrans["text"];
                            tSoundData.translation.push(tarrTrans);
                        }
                    }
                    let tTXTexists = this.isSoundEffectAlreadyAvailable(tSoundData);
                    if (!tTXTexists) {
                        this.mExtLoadedSoundEffects.push(tSoundData);
                    }
                }
            }
        }
        return (Promise.resolve(true));
    }
    isSoundCategoryAlreadyAvailable(pLoadedSoundCategory) {
        let tRes = false;
        for (let tSoundCats of this.mExtLoadedSoundCategory) {
            if (tSoundCats != null) {
                let tSoundCat = tSoundCats.id;
                if (tSoundCat === pLoadedSoundCategory.id) {
                    tRes = true;
                    break;
                }
            }
        }
        return (tRes);
    }
    firstextSoundofCategory(pCategory) {
        let tRes = null;
        for (let textSound of this.mExtLoadedSoundEffects) {
            if (textSound.category === pCategory) {
                tRes = textSound;
                break;
            }
        }
        return (tRes);
    }
    /**
     *
     * starts playing background music
     *
     */
    play_music() {
        if (this.mBackground_Music.soundSet.id.toLocaleLowerCase().trim() === 'none' ||
            !this.mautoPlay_music) {
            this.stop_music();
            return;
        }
        const tsameFile = this.mfileLoaded_music === this.mBackground_Music.soundSet.fileURL;
        this.checkFile(this.mSound_BGMusic, this.mBackground_Music, !tsameFile).then((pFile) => {
            var _b, _c;
            if (pFile == null) {
                Log.error("Failed to load sound file: " + this.mBackground_Music.soundSet.fileURL, ERR_NO_FILE_VIA_URL);
                return;
            }
            if (pFile == true) {
                this._clearTimeouts();
                this.stop_preview();
                if (!((_b = this.mSound_BGMusic) === null || _b === void 0 ? void 0 : _b.isPlaying)) {
                    this.checkFadeInOut(this.mSound_BGMusic, this.mBackground_Music);
                    // this.mSound_BGMusic?.play();
                    return;
                }
            }
            if (!(pFile instanceof ArrayBuffer)) {
                return;
            }
            if (tsameFile && this.mSound_BGMusic && this.mSound_BGMusic.isPlaying) {
                return;
            }
            this.mfileLoaded_music = this.mBackground_Music.soundSet.fileURL;
            (_c = this.mSound_BGMusic) === null || _c === void 0 ? void 0 : _c.stop();
            setTimeout(() => {
                if (this.mSound_BGMusic != null) {
                    this.mSound_BGMusic.dispose();
                    this.mSound_BGMusic = null;
                }
                setTimeout(() => {
                    this._createBG_Music(pFile);
                }, 10);
            }, 50);
        });
    }
    /**
     *
     * starts playing background music
     *
     */
    play_effect() {
        if (this.mBackground_Effect.soundSet.id.toLocaleLowerCase().trim() === 'none' ||
            !this.mautoPlay_effect) {
            this.stop_effect();
            return;
        }
        const tsameFile = this.mfileLoaded_effect === this.mBackground_Effect.soundSet.fileURL;
        this.checkFile(this.mSound_BGEffect, this.mBackground_Effect, !tsameFile).then((pFile) => {
            var _b, _c;
            if (pFile == null) {
                Log.error("Failed to load sound file: " + this.mBackground_Effect.soundSet.fileURL, ERR_NO_FILE_VIA_URL);
                return;
            }
            if (pFile == true) {
                this._clearTimeouts();
                this.stop_preview();
                if (!((_b = this.mSound_BGEffect) === null || _b === void 0 ? void 0 : _b.isPlaying)) {
                    this.checkFadeInOut(this.mSound_BGEffect, this.mBackground_Effect);
                    // this.mSound_BGEffect?.play();
                    return;
                }
            }
            if (!(pFile instanceof ArrayBuffer)) {
                return;
            }
            if (tsameFile && this.mSound_BGEffect && this.mSound_BGEffect.isPlaying) {
                return;
            }
            this.mfileLoaded_effect = this.mBackground_Effect.soundSet.fileURL;
            (_c = this.mSound_BGEffect) === null || _c === void 0 ? void 0 : _c.stop();
            setTimeout(() => {
                if (this.mSound_BGEffect != null) {
                    this.mSound_BGEffect.dispose();
                    this.mSound_BGEffect = null;
                }
                setTimeout(() => {
                    this._createBG_Effect(pFile);
                }, 10);
            }, 50);
        });
    }
    setAudioBackground_init() {
        let tmusicSet = {
            category: RoomManager.AUDIO_BACKGROUND_MUSIC,
            default: false,
            description: '',
            fileURL: '',
            id: 'none'
        };
        let teffectSet = {
            category: RoomManager.AUDIO_BACKGROUND_EFFECT,
            default: false,
            description: '',
            fileURL: '',
            id: 'none'
        };
        let tpreviewSet = {
            category: RoomManager.AUDIO_BACKGROUND_EFFECT,
            default: false,
            description: '',
            fileURL: '',
            id: 'none'
        };
        const tbackground_music = this.firstextSoundofCategory(RoomManager.AUDIO_BACKGROUND_MUSIC);
        const tbackground_effect = this.firstextSoundofCategory(RoomManager.AUDIO_BACKGROUND_EFFECT);
        if (tbackground_music != null) {
            tmusicSet = tbackground_music;
        }
        if (tbackground_effect != null) {
            teffectSet = tbackground_effect;
        }
        this.mBackground_Music = {
            soundSet: tmusicSet,
            fadeIn: true,
            fadeOut: true,
            loop: true,
            autoplay: false,
            volume: 20,
            type: SoundType.music
        };
        this.mBackground_Effect = {
            soundSet: teffectSet,
            fadeIn: false,
            fadeOut: false,
            loop: true,
            autoplay: false,
            volume: 20,
            type: SoundType.effect
        };
        this.mPreview_Data = {
            soundSet: tpreviewSet,
            fadeIn: false,
            fadeOut: false,
            loop: false,
            autoplay: false,
            volume: 20
        };
        this.mSound_Preview = null;
    }
    prepareExtSoundEffectsPropValues() {
        this.mextSoundEffectsPropValueMap = new Map();
        for (let i = 0; i < this.mExtLoadedSoundEffects.length; ++i) {
            const tsndEff = this.mExtLoadedSoundEffects[i];
            let tLang = this.mRoomManager.getLocaleLanguage();
            //XXX
            tLang = "en";
            const tText = this.getSoundEffectsText(i, tLang);
            const tKey = tsndEff.category + RoomManager.CATVALUE_SPLITTER + tsndEff.id;
            const tPropValueExt = new PropertyValue(tKey, tText);
            this.mextSoundEffectsPropValueMap.set(tKey, tPropValueExt);
        }
    }
    getSoundEffectsText(pIdx, pLang) {
        let tRes = "";
        let tlangExists = false;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.mExtLoadedSoundEffects[pIdx].translation.length; i++) {
            tRes = this.mExtLoadedSoundEffects[pIdx].translation[0].text;
            if (this.mExtLoadedSoundEffects[pIdx].translation[i].lang === pLang) {
                tlangExists = true;
                tRes = this.mExtLoadedSoundEffects[pIdx].translation[i].text;
                break;
            }
        }
        if (!tlangExists) {
            tRes = this.getSoundEffectsText(pIdx, 'en');
        }
        return (tRes);
    }
    getSoundEffectPropValue(pCat, pSoundEffectId) {
        const tkey = pCat + RoomManager.CATVALUE_SPLITTER + pSoundEffectId;
        const tsndEffect = this.mextSoundEffectsPropValueMap.get(String(tkey));
        let tRes = null;
        if (tsndEffect != null) {
            tRes = tsndEffect;
        }
        return (tRes);
    }
    getSoundEffectsById(pId) {
        for (const tSEData of this.mExtLoadedSoundEffects) {
            const tid = tSEData.category + RoomManager.CATVALUE_SPLITTER + tSEData.id;
            if (tid === pId) {
                return (tSEData);
            }
        }
        return (null);
    }
    getSoundEffectsTextByEntry(pEntry, pLang) {
        let tRes = "";
        let tlangExists = false;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < pEntry.translation.length; i++) {
            tRes = pEntry.translation[0].text;
            if (pEntry.translation[i].lang === pLang) {
                tlangExists = true;
                tRes = pEntry.translation[i].text;
                break;
            }
        }
        if (!tlangExists) {
            tRes = this.getSoundEffectsTextByEntry(pEntry, 'en');
        }
        return (tRes);
    }
    isSoundEffectAlreadyAvailable(pLoadedSoundEffect) {
        let tRes = false;
        for (let tSoundData of this.mExtLoadedSoundEffects) {
            if (tSoundData != null) {
                const tnewSet = pLoadedSoundEffect.category + RoomManager.CATVALUE_SPLITTER + pLoadedSoundEffect.id;
                const texSet = tSoundData.category + RoomManager.CATVALUE_SPLITTER + tSoundData.id;
                if (tnewSet === texSet) {
                    tRes = true;
                    break;
                }
            }
        }
        return (tRes);
    }
    stopAudio(pSound) {
        if (pSound != null) {
            pSound.stop();
            setTimeout(() => {
                if (pSound != null) {
                    pSound.dispose();
                    pSound = null;
                }
            }, 10);
        }
    }
    stopAllSound() {
        this.stop_preview();
        this.stop_music();
        this.stop_effect();
    }
    _clearTimeouts() {
        for (const tTO of this.marr_TimeOut) {
            clearTimeout(tTO);
        }
    }
    _createBG_Music(pFile) {
        var _b;
        const tadM = this.mBackground_Music;
        this.mSound_BGMusic = new Sound("sound_BGMusic", pFile, this.mRoomManager.app.scene, this.bgMusic_ReadyToPlay, { loop: false, autoplay: false, volume: tadM.volume * 0.01 });
        (_b = this.mSound_BGMusic) === null || _b === void 0 ? void 0 : _b.onEndedObservable.add(this.bgMusic_ended);
    }
    _createBG_Effect(pFile) {
        var _b;
        const tadE = this.mBackground_Effect;
        this.mSound_BGEffect = new Sound("sound_BGEffect", pFile, this.mRoomManager.app.scene, this.bgEffect_ReadyToPlay, { loop: true, autoplay: false, volume: tadE.volume * 0.01 });
        (_b = this.mSound_BGEffect) === null || _b === void 0 ? void 0 : _b.onEndedObservable.add(this.bgEffect_ended);
    }
    bgMusic_ended(pSound, eventState) {
        this.checkFadeInOut(pSound, this.mBackground_Music);
    }
    bgEffect_ended(pSound, eventState) {
        this.checkFadeInOut(pSound, this.mBackground_Effect);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    checkFadeInOut(pSound, pAudioData) {
        var _b;
        if (!pSound ||
            pSound.isPaused ||
            !pAudioData.loop) {
            return;
        }
        let tfadeInTime = 2;
        let tfadeOutTime = 2;
        const tduration = (_b = pSound.getAudioBuffer()) === null || _b === void 0 ? void 0 : _b.duration;
        if (!tduration || tduration < 6) {
            tfadeInTime = 0;
            tfadeOutTime = 0;
        }
        const tfadeOutDone = pAudioData.type == SoundType.music ? this.fadeInDoneMusic : this.fadeInDoneEffect;
        // fade in
        if (pAudioData.fadeIn && !tfadeOutDone) {
            if (pAudioData.type == SoundType.music) {
                this.fadeInDoneMusic = true;
            }
            else {
                this.fadeInDoneEffect = true;
            }
            pSound.setVolume(0);
            pSound.setVolume(pAudioData.volume * 0.01, tfadeInTime);
            pSound.play();
        }
        else {
            pSound.setVolume(pAudioData.volume * 0.01);
            pSound.play();
        }
        // fade out; disabled 2024-04-24
        // if (pAudioData.fadeOut) {
        //     if (tduration != null && !isNaN(tduration)) {
        //         const tdelay = (tduration - tfadeOutTime) * 1000;
        //         this.marr_TimeOut.push(setTimeout(() => {
        //             pSound.setVolume(0, tfadeOutTime);
        //         }, tdelay));
        //     }
        // }
    }
    resume_Play() {
        this.autoPlay_music = this.mMusic_played;
        this.autoPlay_effect = this.mEffect_played;
        this.mMusic_played = false;
        this.mEffect_played = false;
    }
    prepareValueLists() {
        this.preparePropList_effects();
        this.preparePropList_music();
    }
    async getSoundEffectList() {
        if (!this.mextSoundEffectisLoading) {
            this.mextSoundEffectisLoading = true;
            this.mExtLoadedSoundEffects = [];
            this.mExtLoadedSoundCategory = [];
            await this.loadSoundFiles().then(() => {
                this.prepareExtSoundEffectsPropValues();
                this.preparePropList_effects();
                this.preparePropList_music();
                this.mextSoundEffectisLoading = false;
                BackgroundSound.eventSoundListLoaded.trigger({});
            });
        }
    }
}
_a = BackgroundSound;
BackgroundSound.eventSoundListLoaded = new ListenableEvent(_a);
//// private ///////////////////////////////////////////////////////////////////////////////
BackgroundSound.BACKGROUND_MUSIC = 'background_music';
BackgroundSound.BACKGROUND_EFFECT = 'background_effect';
